<template>
    <div>
        <MetaDataComponent title="Prämien umtauschen"/>
        <RewardScreenHeader/>
        <div class="special-row row">
            <div class="col-lg-12 col-xs-12">
                <h2 style="margin-bottom: 1.5rem;">Special</h2>
                <div class="sponsor_banner_container" :style="selectedImage.background">
                    <div class="col-md-12 col-lg-10 sponsor_panel">
                        <div class="row">
                            <div class="col-md-7 col-md-offset-2 col-xs-12">
                                <a :href="selectedImage.link" :target="selectedImage.target">
                                    <img
                                        :src="selectedImage.image"
                                        class="sponsor_banner"
                                        :alt="selectedImage.alt">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="waves">
                        <svg preserveAspectRatio="none" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 368 38.08" id="waves-svg"
                             style="position: absolute; bottom: -3px; width: 130%; left: -50px; z-index: 2">
                            <path class="cls-1"
                                  d="M0,108.56c7.29-3.1,23.2-8.93,50.2-9.25,15.65-.19,28.29,2.53,45.8,5.21,22.21,3.4,22.46,4.24,34.23,5.21,23.18,1.92,29-4.49,60.77-5.89,31.33-1.37,36.11,5,69,4,30.48-.93,35.28-5.38,72.83-5.88,20.69-.28,29.45.58,35.17,2.85V111H0Z"
                                  transform="translate(0 -73)"></path>
                            <path class="cls-2"
                                  d="M368,100.53c-7.43-9.44-13.71-26.72-40.53-27.49-15.55-.45-31.79,3.34-49,11.68-21.84,10.57-30.37,10.47-42,13.54-22.89,6-27-6.55-58.69-10.57-31.18-4-34.54,11-67.25,8.2C80.2,93.29,75.16,79.71,37.85,78.45,17.29,77.75,5.54,81.8,0,88.8c0,0,.33,22.12,0,22.23s367,0,368,0Z"
                                  transform="translate(0 -73)"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="reward-list-row">
            <h2 style="margin-bottom: 0;">Prämien</h2>
            <div class="col-md-12" v-if="!canOrderReward && this.userProfileResult.loaded">
                <div class="no-address-alert panel alert-info">
                    <h4 class="alert-heading">Bitte trag deine Adresse ein, um Gutscheine zu bestellen.</h4>
                    <div class="address-not-set-warning-container">
                        Um Gutscheine bestellen zu können, musst du deine Adresse angeben. Diese benötigen wir aus
                        steuerechtlichen Gründen, um dir einen Gutschein auszahlen zu dürfen.
                    </div>
                    <div class="link-to-user-profile-btn">
                        <router-link to="/profile">
                            <button class="btn btn-primary to-user-profile-button">
                                Jetzt eintragen
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="availableRewardsResult.loaded && !availableRewardsResult.error"
                 v-for="(row, index) in getRewardRows(availableRewardsResult.rewards)" class="row">
                <DonationReward class="col-md-6 col-sm-6 col-xs-12 col-lg-3" v-if="index === 0"/>
                <RewardGroupComponent
                    class="col-md-6 col-sm-6 col-xs-12 col-lg-3" v-for="reward in row"
                    :key="reward.id"
                    :uuid="reward.id"
                    :title="reward.title"
                    :description="reward.description"
                    :logo="reward.logo"
                    :minPrice="reward.minPrice"
                    :maxPrice="reward.maxPrice"
                    :rewards="reward.rewards"
                    :isActive="enoughCoins(reward) && rewardAvailable(reward.rewards)"
                    :showRewardValueInTitle="reward.showRewardValueInTitle"
                />
            </div>
        </div>

        <div
            v-if="availableRewardsResult.loaded && (availableRewardsResult.error || availableRewardsResult.rewards.length === 0)">
            <ErrorComponent :icon="'dev-gift'" message="Keine Rewards verfügbar :-(" style="text-align: center">Leider
                gibt es zur Zeit keine Prämien. Schau bald wieder vorbei!
            </ErrorComponent>
        </div>
        <div class="row" style="margin: 3rem auto">
            <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                <router-link :to="{ name: 'challenge-list'}">
                    <button class="btn btn-primary"><i class="dev-search">&nbsp;</i>Challenges anzeigen</button>
                </router-link>
            </div>
        </div>
        <UserCoinsOverlay/>
    </div>
</template>

<script>
import {services} from "../main.js"
import {eventBus} from "../main.js"
import RewardGroupComponent from "../components/rewards/RewardGroupComponent";
import UserCoinsOverlay from "../components/rewards/UserCoinsOverlay";
import ErrorComponent from "../components/ErrorComponent";
import DonationReward from "../components/rewards/DonationRewardComponent";
import RewardScreenHeader from "../components/rewards/RewardScreenHeader.vue";

export default {
    name: "RewardGroupListView",
    components: {DonationReward, ErrorComponent, RewardGroupComponent, UserCoinsOverlay, RewardScreenHeader},
    data() {
        return {
            availableRewardsResult: services.rewardService.getAvailableRewards(),
            userCoinsApiResult: services.rewardService.getUserCoins(),
            userProfileResult: services.userService.getUserProfile(),
            selectedImage: {},
        }
    },
    created() {
      this.selectedImage = this.getRandomImage();
    },
    mounted() {
        eventBus.$on("user-coins-changed", () => {
            this.userCoinsApiResult = services.rewardService.getUserCoins(false, this.availableRewardsResult.coins);
        })
        eventBus.$on('reload-reward-list', () => {
            this.availableRewardsResult = services.rewardService.getAvailableRewards();
        })
    },
    beforeDestroy() {
        eventBus.$off('reload-reward-list');
    },
    computed: {
        images: function () {
            return [
                {
                    alt: "Rheinwerk - JavaScript: Dynamisch in jeder Hinsicht",
                    image: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-javascript-11-24-quer`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-javascript-11-24-link",
                    target: "_blank",
                    fontColor: "#265ea9",
                    brandedEHLogo: "https://res.cloudinary.com/dspi5zyaa/image/upload/v1709547674/rheinwerk-kotin-banner/eh-logo-rheinwerk-blue.svg",
                },
                {
                    alt: "Rheinwerk - Kotlin: Saubere und klare Syntax mit Kotlin",
                    image: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-kotlin-11-24-quer`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-kotlin-11-24-link",
                    target: "_blank",
                    fontColor: "#265ea9",
                    brandedEHLogo: "https://res.cloudinary.com/dspi5zyaa/image/upload/v1709547674/rheinwerk-kotin-banner/eh-logo-rheinwerk-blue.svg",
                },
                {
                    alt: "Rheinwerk - PHP: Dynamische Webseiten entwickeln ohne Vorwissen",
                    image: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-php-11-24-quer`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-php-11-24-link",
                    target: "_blank",
                    fontColor: "#265ea9",
                    brandedEHLogo: "https://res.cloudinary.com/dspi5zyaa/image/upload/v1709547674/rheinwerk-kotin-banner/eh-logo-rheinwerk-blue.svg",
                },
                {
                    alt: "Rheinwerk - Python: Übersichtlich, einfach und mit großem Potenzial",
                    image: `https://company.platform.entwicklerheld.de/link/banner-rheinwerk-python-11-24-quer`,
                    link: "https://company.platform.entwicklerheld.de/link/banner-rheinwerk-python-11-24-link",
                    target: "_blank",
                    fontColor: "#265ea9",
                    brandedEHLogo: "https://res.cloudinary.com/dspi5zyaa/image/upload/v1709547674/rheinwerk-kotin-banner/eh-logo-rheinwerk-blue.svg",
                }
            ];
        },
        canOrderReward() {
            if (!this.userProfileResult.loaded || this.userProfileResult.error) {
                return true;
            }

            return (
                this.userProfileResult.user_profile.first_name &&
                this.userProfileResult.user_profile.last_name &&
                this.userProfileResult.user_profile.city &&
                this.userProfileResult.user_profile.address &&
                this.userProfileResult.user_profile.zipCode &&
                this.userProfileResult.user_profile.country
            )
        }
    },
    methods: {
        getRandomImage() {
            return this.images[Math.floor(Math.random() * this.images.length)];
        },
        enoughCoins(reward) {
            return reward.minPrice <= this.userCoinsApiResult.coins;
        },
        rewardAvailable(rewards) {
            for (let reward of rewards) {
                if (reward.remainingRewards === null || reward.remainingRewards > 0) {
                    return true;
                }
            }
            return false;
        },
        getRewardRows() {
            let rewardList = this.availableRewardsResult.rewards.slice();
            let index, rewardCount, chunk = 4;
            let rewardRows = [];
            for (index = 0, rewardCount = this.availableRewardsResult.rewards.length; index < rewardCount; index += chunk) {
                if (window.ENTWICKLER_HERZ_FEATURE_FLAG && index === 0) {
                    chunk = 3
                } else {
                    chunk = 4
                }
                rewardRows.push(rewardList.slice(index, index + chunk));
            }
            return rewardRows;
        }
    }
}
</script>
<style scoped>
.alert-heading {
    font-weight: 400;
}

.to-user-profile-button {
    margin-top: 5px;
}

.sponsor_banner {
    /* make image match without borders */
    margin: auto -15px;
    width: calc(100% + 31px);
    position: relative;
    z-index: 10;
}

.sponsor_banner_container {
    background-image: none;
    background-size: 250%;
    background-position: 0 0;
    border-radius: 10px;
    padding: 1rem;
}

@media (max-width: 1750px) {
  .sponsor_banner_container {
    background-size: 600%;
    background-position: right bottom;
  }
}

.sponsor_panel {
    max-width: 1500px;
    float: none;
    margin: 2rem auto;
}

.sponsor_panel_container > .panel {
    background: linear-gradient(0deg, #f4f4f4, white);
    z-index: 12;
    position: relative;
    border-bottom: 10px solid #ffbb22;
}

.waves {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 130%;
    z-index: 0;
}

.cls-1, .cls-2 {
    fill: #fff;
    opacity: 0.16;
}

.cls-2 {
    opacity: 0.03;
}

.reward-list-row {
    margin-top: 3rem;
}

.no-address-alert {
    margin-top: 2rem;
    margin-bottom: 4rem;
}
</style>
